import { cva } from 'class-variance-authority';

const controlChromeVariants = cva(
	'rounded-control border border-border-strong bg-surface-control text-foreground transition-colors outline-none placeholder:text-foreground-subtle hover:border-foreground/30 focus-visible:border-focus focus-visible:ring-3 focus-visible:ring-focus/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-surface-hover disabled:opacity-50 aria-invalid:border-danger aria-invalid:ring-3 aria-invalid:ring-danger/20 dark:aria-invalid:border-danger/50 dark:aria-invalid:ring-danger/40',
);

const backdropVariants = cva(
	'fixed inset-0 z-backdrop transition-opacity data-ending-style:opacity-0 data-starting-style:opacity-0',
	{
		variants: {
			strength: {
				default: 'bg-overlay',
				strong: 'bg-overlay-strong',
			},
			motion: {
				fast: 'duration-fast',
				standard: 'duration-standard',
				deliberate: 'duration-deliberate',
			},
		},
		defaultVariants: { strength: 'default', motion: 'standard' },
	},
);

const panelElevationVariants = cva('border border-border text-foreground', {
	variants: {
		elevation: {
			none: 'shadow-none',
			flyout: 'shadow-flyout',
			overlay: 'shadow-overlay',
		},
		surface: {
			default: 'bg-surface',
			raised: 'bg-surface-raised',
			control: 'bg-surface-control',
		},
	},
	defaultVariants: { elevation: 'none', surface: 'default' },
});

const statusToneVariants = cva('', {
	variants: {
		tone: {
			neutral: 'text-foreground-body',
			action: 'text-action',
			success: 'text-success',
			warning: 'text-warning',
			danger: 'text-danger',
		},
	},
	defaultVariants: { tone: 'neutral' },
});

const statusBadgeToneVariants = cva('', {
	variants: {
		tone: {
			neutral: 'bg-surface-hover text-foreground-body',
			action: 'bg-action/10 text-action',
			success: 'border-success/30 bg-success/10 text-success',
			warning: 'bg-warning/10 text-warning',
			danger: 'bg-danger/10 text-danger dark:bg-danger/20',
		},
	},
	defaultVariants: { tone: 'neutral' },
});

const statusFillToneVariants = cva('', {
	variants: {
		tone: {
			neutral: 'bg-foreground-body',
			action: 'bg-action',
			success: 'bg-success',
			warning: 'bg-warning',
			danger: 'bg-danger',
		},
	},
	defaultVariants: { tone: 'neutral' },
});

type StatusTone = 'neutral' | 'action' | 'success' | 'warning' | 'danger';

export {
	backdropVariants,
	controlChromeVariants,
	panelElevationVariants,
	statusBadgeToneVariants,
	statusFillToneVariants,
	statusToneVariants,
};
export type { StatusTone };
